export default __webpack_public_path__ + "locales/nl/Settings.json?hash=421c8c30797f7b74dc1493e259578588";